import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

export const FilterByCategory = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.categories);
  const selectedFilters = useSelector((state) => state.utilization.selectedCategoryFiltersDisplay);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Select Category"
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateCategory(data))}
    />
  );
};
